<script lang="ts">
    import { UsersRepository } from '../../../modules/usersApi/users/users.repository'
    import { UsersService } from '../../../modules/usersApi/users/users.service'
    import { get_current_component } from 'svelte/internal'
    import { createEventDispatcher } from 'svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { navigateTo } from 'yrv'
    const dispatch = createEventDispatcher()

    const usersRep = new UsersRepository()
    const usersS = new UsersService(usersRep)

    const me = get_current_component()
    let show = false
    let step = 1
    let name = ''
    let phone = ''
    let smsCode = ''
    let pass1 = ''
    let pass2 = ''
    let email = ''

    async function evaluateStep1() {
        try {
            show = true
            await window.api.users.auth.requestSignupBySMS({ phone })
            step = 2
        } catch (error) {
            console.log('err', error)
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let logged
    async function evaluateStep2() {
        try {
            show = true
            logged = await window.api.users.auth.loginBySMS({ phone, smsCode })
            step = 3
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function evaluateStep3() {
        if (pass1.length !== pass2.length) {
            evaluateError('As senhas não conferem.')
            return
        }
        try {
            show = true
            await window.api.users.auth.createPassword({ password: pass1 })
            step = 4
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function evaluateStep4() {
        try {
            show = true
            if (!email || !name) {
                window.error('Informe seu nome e e-mail')
                return
            }
            if (!email.includes('@')) {
                window.error('Informe um e-mail válido')
                return
            }
            await usersS.updateInfoFromLoggedUser({ email, userName: name })
            finish()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function finish() {
        step = 5
        dispatch('success', {})
    }

    function restart() {
        step = 1
    }

    function evaluateError(error) {
        window.error(error)
    }

    function goLogin() {
        navigateTo('/login')
    }
</script>

<div class="root">
    {#if step === 1}
        <div class="input-group mb-2">
            <label for="" class="input-group-text">Seu celular</label>
            <input class="form-control" placeholder="Seu celular" bind:value={phone} type="text" />
        </div>
        <button class="btn btn-primary mb-2" on:click={evaluateStep1}>Avançar</button>
        <button class="btn btn-link mt-2" on:click={goLogin}>Já possuo conta e quero fazer login</button>
    {/if}
    {#if step === 2}
        <div class="input-group mb-2">
            <label for="" class="input-group-text">Código WhatsApp</label>
            <input class="form-control" placeholder="XXX XXX" bind:value={smsCode} type="text" />
            <div class="text-muted">Enviamos um código para seu WhatsApp.</div>
        </div>
        <button class="btn btn-primary" on:click={evaluateStep2}>Confirmar</button>
    {/if}
    {#if step === 3}
        <div class="input-group mb-2">
            <label for="" class="input-group-text">Seu celular</label>
            <input disabled class="form-control" value={phone} type="text" />
            <!-- <button on:click={restart} class="btn btn-secondary">Corrigir</button> -->
        </div>
        <div class="input-group mb-2">
            <label for="" class="input-group-text">Crie uma senha</label>
            <input class="form-control" bind:value={pass1} type="password" />
        </div>
        <div class="input-group mb-2">
            <label for="" class="input-group-text">Confirme sua senha</label>
            <input class="form-control" bind:value={pass2} type="password" />
        </div>
        <button class="btn btn-primary" on:click={evaluateStep3}>Salvar</button>
    {/if}
    {#if step === 4}
        <div class="input-group mb-2">
            <label for="" class="input-group-text">Seu primeiro nome</label>
            <input class="form-control" bind:value={name} type="text" />
        </div>

        <div class="input-group mb-2">
            <label for="" class="input-group-text">Seu melhor e-mail</label>
            <input class="form-control" bind:value={email} type="text" />
        </div>
        <button class="btn btn-primary" on:click={evaluateStep4}>Entrar</button>
    {/if}
    {#if step === 5}
        <div class="center">Seu cadastro foi concluído com sucesso.</div>
    {/if}
    <LoadSpinner {show} />
</div>

<style>
    .root {
        display: flex;
        flex-direction: column;
        max-width: 420px;
        margin: 0 auto;
    }
    .center {
        text-align: center;
    }
    .btn-link {
        color: white;
    }
</style>
